import React from 'react';
import { formatCompanyDateTime } from '../utils/companyDateFormat';
import { CheckCircle, AlertCircle } from 'lucide-react';
import type { AttendanceImportBatchRowResult } from '../types';

export function formatImportDateTime(iso: string | null | undefined): string {
  if (iso == null || String(iso).trim() === '') return '—';
  return formatCompanyDateTime(iso) || String(iso);
}

function rowStatusLooksOk(status: string): boolean {
  return status === 'Valid' || status === 'Imported' || status === 'Deleted';
}

export function AttendanceImportRowsPreviewTable({ rows }: { rows: AttendanceImportBatchRowResult[] }) {
  return (
    <div className="max-h-[min(24rem,55vh)] overflow-auto rounded border">
      <table className="w-full text-left text-xs">
        <thead className="sticky top-0 bg-gray-100">
          <tr>
            <th className="px-2 py-1.5">Row</th>
            <th className="px-2 py-1.5">Status</th>
            <th className="px-2 py-1.5">Name</th>
            <th className="whitespace-nowrap px-2 py-1.5">In</th>
            <th className="whitespace-nowrap px-2 py-1.5">Out</th>
            <th className="px-2 py-1.5">Message</th>
          </tr>
        </thead>
        <tbody>
          {rows.map((r) => (
            <tr key={r.id} className="border-t">
              <td className="px-2 py-1">{r.excelRowNumber}</td>
              <td className="px-2 py-1">
                {rowStatusLooksOk(r.status) ? (
                  <span className="inline-flex items-center gap-1 text-green-700">
                    <CheckCircle className="h-3 w-3" /> {r.status}
                  </span>
                ) : (
                  <span className="inline-flex items-center gap-1 text-red-700">
                    <AlertCircle className="h-3 w-3" /> {r.status}
                  </span>
                )}
              </td>
              <td className="px-2 py-1">{r.employeeNameRaw ?? '—'}</td>
              <td className="whitespace-nowrap px-2 py-1 text-gray-800">{formatImportDateTime(r.clockInUtc ?? undefined)}</td>
              <td className="whitespace-nowrap px-2 py-1 text-gray-800">{formatImportDateTime(r.clockOutUtc ?? undefined)}</td>
              <td className="px-2 py-1 text-gray-600">{r.errorMessage ?? '—'}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
